/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.

  Modified by yang@onerockwell

==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  Handlebars Helper Functions
==============================================================================*/
Handlebars.registerHelper('ifeq', function (a, b, options) {
  return (a == b) ? options.fn(this) : options.inverse(this);
});
Handlebars.registerHelper('unlesseq', function (a, b, options) {
  return (a == b) ? options.inverse(this) : options.fn(this);
});
/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
  console.log('update cart', cart);
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeUpdateCartNote.ajaxCart', note);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
  Yang@onerockwell Added ShopifyAPI.addMultipleItems
==============================================================================*/
ShopifyAPI.addMultipleItems = function(data, callback, errorCallback) {
    data.sections = 'mini-cart';
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            beforeSend: function(jqxhr, settings) {
                $body.trigger('beforeAddItem.ajaxCart');
            },
            success: function(line_item) {
                if ((typeof callback) === 'function') {
                    callback(line_item);
                } else {
                    ShopifyAPI.onItemAdded(line_item);
                }
                $body.trigger('afterAddItem.ajaxCart', [line_item]);
            },
            error: function(XMLHttpRequest, textStatus) {
                if ((typeof errorCallback) === 'function') {
                    errorCallback(XMLHttpRequest, textStatus);
                } else {
                    ShopifyAPI.onError(XMLHttpRequest, textStatus);
                }
                $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
                document.dispatchEvent(new CustomEvent('cart-updated'));
            }
        };
    jQuery.ajax(params);
};

ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var $body = $(document.body),
      data = jQuery(form).serialize();
  data = `${data}&sections=mini-cart`
  params = {
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    beforeSend: function(jqxhr, settings) {
      $body.trigger('beforeAddItem.ajaxCart', form);
    },
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
      $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
      document.dispatchEvent(new CustomEvent('cart-updated'));
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if (cart.item_count === 1 && cart.items[0].handle === 'gift-wrap') {
      ShopifyAPI.clearCart(callback);
    } else {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};

ShopifyAPI.clearCart = function(callback) {
  jQuery.getJSON('/cart/clear.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      const updateCountPrice = true;
      callback(cart);
    } else {
      location.reload();
    }
  })
}

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line + '&sections=mini-cart',
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
      document.dispatchEvent(new CustomEvent('cart-updated'));
    }
  };
  jQuery.ajax(params);
};



/*============================================================================
  Product Options
==============================================================================*/
ShopifyAPI.selectCallback = function(variant, selector) {
  if (!variant) return;

  let variant_id = variant.id;

  if (variant_id) {
    fetch(window.Shopify.routes.root + `variants/${variant_id}/?section_id=product-availability`)
    .then(response => response.text())
    .then(text => {
      const container = document.querySelector('[data-store-availability-container]');
      const pickupAvailabilityHTML = new DOMParser()
        .parseFromString(text, 'text/html')
        .querySelector('.shopify-section');
      while(container.firstElementChild) {
        container.firstElementChild.remove();
      }

      container.appendChild(pickupAvailabilityHTML);
      document.dispatchEvent(new CustomEvent('availability-update'));
    })
    .catch(e => {
      console.error(e);
    });
  }

    // var moneyFormat = Shopify.money_format;
    var moneyFormat = theme.moneyFormat;
    // Selectors
    if ( selector.domIdPrefix.split('-').length > 1 ) {
        var selectorArray = selector.domIdPrefix.split('-');
        var $addToCart = $('#AddToCart-' + selectorArray[1]);
    } else {
        var $addToCart = $('#AddToCart');
    }

    var $productWrapper = $addToCart.parents('.product-info'), // Defined the Product Dom Scope
        $productPrice = $productWrapper.find('.product-price'),
        $comparePrice = $productWrapper.find('.product-compare-price'),
        $addToCartText = $productWrapper.find('.add-to-cart-text'),
        $sizeSwatches = $productWrapper.find('.selector-wrapper.oneswatch.size'),
        $selectedSwatch = $sizeSwatches.find('.swatch-label .value');


    // Variant
    if (variant) {
        // Select a valid variant if available
        if (variant.available) {

            // Available, enable the submit button, change text, show quantity elements
            if ($addToCart.attr('data-variant-selected') || $selectedSwatch.length == 1 || $sizeSwatches.length == 0 ){ // variant selected or there is not variant to select (no other size)
              $addToCart.removeClass('disabled select-size').prop('disabled', false);
            }
            $('.klaviyo-bis-trigger').css('display','none');
            if ($addToCart.hasClass('pre-order')) {
                $addToCartText.html('pre-order');
                $addToCart.attr('data-variant-selected', true);
            } else {
                var text = !$addToCart.attr('data-variant-selected') ? $addToCartText.text() : 'add to bag';
                $addToCartText.html(text);
                $addToCart.attr('data-variant-selected', true);
            }
        } else {
            // Sold out, disable the submit button, change text, hide quantity elements
            $addToCart.addClass('disabled').prop('disabled', true);
            $('.klaviyo-bis-trigger').css('display','block');
            if (!$addToCart.hasClass('inquire')) {
                $addToCartText.html('Notify Me');
            }
        }

        const savings =
        100 *
        (1 -
          variant.price /
            Math.max(variant.price, variant.compare_at_price));
        
        const finalSaleThreshold = parseFloat($productWrapper[0].dataset.finalSaleThreshold);
        const finalSale = 'hasFinalSaleTag' in $productWrapper[0].dataset;
        if ($productWrapper[0].querySelector(".final-sale-tag")) {
          $productWrapper[0].querySelector(".final-sale-tag").style.display = finalSale ? null : 'none';
        }

        const finalSaleInput = $productWrapper[0].querySelector('#final-sale');
        if (finalSaleInput) {
          finalSaleInput.name = finalSale ? finalSaleInput.dataset.name : '';
        }

        // Regardless of stock, update the product price
        $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

        // Also update and show the product's compare price if necessary
        if (variant.compare_at_price > variant.price) {
            $comparePrice.html(Shopify.formatMoney(variant.compare_at_price, moneyFormat)).show();
        } else {
            $comparePrice.hide();
        }

        // Marker for running this block, prevent overwrite of initial run.
        $addToCart.addClass('add-to-cart-status-set');

        // 1R Yang : adding currency change trigger
        // mlvedaload();
    } else if ($addToCart.hasClass('add-to-cart-status-set')) {
      console.log("Add to cart button text and attr already set");
    } else {
        if (!$addToCart.attr('data-variant-selected')){
          $addToCart.addClass('disabled').prop('disabled', true);
          $('.klaviyo-bis-trigger').css('display','block');
          if (!$addToCart.hasClass('inquire')) {
              $addToCartText.html('Notify Me');
          }
        };
    }
};
/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body, items, item, data;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty, giftWrap, checkMaxChar;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true,
      enableGiftWrap : true,
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }
    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  const adjustUpsellBlock = (function () {
  let observerInitialized = false;

  return function () {
    const cartEl = $cartContainer[0];
    if (!cartEl) return;

    const ajaxCartInner = cartEl.querySelector('.ajaxcart__inner');
    const ajaxFooter = cartEl.querySelector('.ajaxcart__footer');
    const productWrap = cartEl.querySelector('.cart-upsell__items');
    const upsellComponent = cartEl.querySelector('component-cart-upsell');
    const upsellContent = cartEl.querySelector('[data-upsell-content]');
    const buffer = 30;

    if (!ajaxCartInner || !ajaxFooter || !productWrap || !upsellComponent) return;

    let lastInlineState = null;
    let lastOpenedState = null;

    const updateSpacing = () => {
      const innerRect = ajaxCartInner.getBoundingClientRect();
      const footerRect = ajaxFooter.getBoundingClientRect();
      const distance = footerRect.top - innerRect.bottom;

      // Toggle item-inline class based on buffer
      const isInline = distance <= buffer || distance === 0;
      if (lastInlineState !== isInline) {
        productWrap.classList.toggle('item-inline', isInline);
        lastInlineState = isInline;
      }

      // Toggle upsell open/closed
      const shouldOpen = distance > 0; // can adjust buffer if needed
      if (lastOpenedState !== shouldOpen) {
        $(upsellContent).stop(true, true); // stop ongoing animations
        if (shouldOpen) {
          upsellComponent.classList.add('opened');
          $(upsellContent).slideDown(200);
          localStorage.setItem('cart-upsell-opened', 'true');
        } else {
          upsellComponent.classList.remove('opened');
          $(upsellContent).slideUp(200);
          localStorage.setItem('cart-upsell-opened', 'false');
        }
        lastOpenedState = shouldOpen;
      }

      console.log(
        'Distance:', distance,
        'Inline:', productWrap.classList.contains('item-inline'),
        'Opened:', upsellComponent.classList.contains('opened')
      );
    };

    if (!observerInitialized) {
      const observer = new MutationObserver(() => requestAnimationFrame(updateSpacing));
      observer.observe(ajaxCartInner, { childList: true, subtree: true });
      observer.observe(ajaxFooter, { childList: true, subtree: true });
      observer.observe(productWrap, { childList: true, subtree: true });
      observerInitialized = true;
    }

    updateSpacing();
  };
  })();

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');
      document.getElementById("cart-title-count").innerHTML = cart.item_count;
      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {
        evt.preventDefault();

        var proceed = true;
        var $currForm = $(evt.target);
        var $selects = $currForm.find('select');
        $.each($selects, function(i,v){
            if ($(v).val() == '') {
                proceed = false;
                return false;
            }
        });

        if (!proceed) {
            alert('Please select all options');
            return false;
        }

        // Add class to be styled if desired
        $addToCart.removeClass('is-added').addClass('is-adding');

        // Remove any previous quantity errors
        $('.qty-error').remove();

        ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');
    ShopifyAPI.getCart(function (cart) {
        cartUpdateCallback(cart);
        $body.trigger('afterAddToCart.ajaxCart', cart);
        document.getElementById("CartContainer").classList.remove("empty");
        document.getElementById("MiniCart").classList.add("opened");

    });
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function (cart) {
    // Show empty cart
    if (cart.item_count === 0) {
      // Start with a fresh cart div
      $cartContainer.empty();
      $cartContainer
        .append('<div class="ajaxcart__empty text-center"><p style="font-size: 24px;">Your Bag Is Empty</p>Looks like your bag is empty.</div><p><a class="cta" href="/collections/just-in">Shop Now!</a></p>')
        .addClass("empty");
      cartCallback(cart);
      return;
    } else {
      $.getJSON('/?sections=mini-cart', (cartHtml) => {
        const miniCartHtml = cartHtml['mini-cart'];
        const cartContainer = new DOMParser()
          .parseFromString(miniCartHtml, 'text/html')
          .querySelector('#CartContainer');

        if ((cart.item_count === 1 && !window.itemAddedFromUpsell) || $cartContainer[0].querySelector('.ajaxcart__empty')) {
          // If was empty content before, overwrite all content.
          $cartContainer.html(cartContainer.innerHTML)
        } else {
          const ajaxCartInner = cartContainer.querySelector('.ajaxcart__inner')
          const freeShpipingNote = cartContainer.querySelector('.free-shipping-note')
          const ajaxFooterMain = cartContainer.querySelector('.ajaxcart__footer__main')

          if (freeShpipingNote) {
            $cartContainer.find('.free-shipping-note').html(freeShpipingNote.innerHTML)
          }
          if (ajaxCartInner) {
            $cartContainer.find('.ajaxcart__inner').html(ajaxCartInner.innerHTML)
          }
          if (ajaxFooterMain) {
            $cartContainer.find('.ajaxcart__footer__main').html(ajaxFooterMain.innerHTML)
          }
        }

        window.itemAddedFromUpsell = false

        // const $upsellWrapper = $cartContainer.find('.cart-upsell-wrap');
        // const $upsell = $cartContainer.find('component-cart-upsell');
        // const $upsellContent = $cartContainer.find('[data-upsell-content]');
        // if (!$upsell.hasClass('opened')) {
        //   $upsellWrapper.addClass('is-sticky');
        //   $upsell.addClass('opened');
        //   $upsellContent.show();
        // }

        //klarna refresh
        window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
      });
      
      cartCallback(cart);
    }
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    $body.on('click', '.ajaxcart__qty-remove', function(e) {
        e.preventDefault();
        var $el = $(this),
            line = $el.data('line');

        if (isUpdating) {
            return;
        }
        updateQuantity(line, 0);
    });

    // Update quantity based on edit button click
    $body.on('click', '.ajaxcart__edit', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this).siblings('.ajaxcart__qty-num'),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      isUpdating = false;
      ShopifyAPI.getCart(cartUpdateCallback);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('.responsive-table-row input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.attr('id').replace('updates_', ''),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.closest('.js-qty').find('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);

        // Update cart in shopify
        $.ajax({
          type: "POST",
          async: false,
          url: window.Shopify.routes.root + 'cart/change.js',
          data: {
            'id': id,
            'quantity': qty,
            'sections': 'mini-cart'
          },
          dataType: 'json',
          success: function(data) {
            window.location.reload();
          },
          error: function(jqXHR, textStatus, errorThrown) {
              console.error("Error, status = " + textStatus + ", " +
                "error thrown: " + errorThrown
              );
          }
          });
      });
    }
  };
  
//giftwrap functionality
   document.addEventListener('change', (e)=>{
    if(e.target.id == "gift-wrap-check"){
      document.getElementById("gift-info").classList.toggle("active");
      if (e.target.classList.contains("edit")){

        e.target.checked = true;
      }
      if(e.target.checked){
        let giftMessage = document.getElementById("gift-note"),
            giftRecipient = document.getElementById("gift-recipient");
        let characterCounter = document.getElementById("char-count");
        const maxChars = 300;
         giftMessage.addEventListener("input", function(){
          characterCounter.innerHTML = (maxChars - giftMessage.value.length) + `/${maxChars}`;
        });
      }
    }
  });
  document.getElementById("MiniCart").addEventListener("click", (e)=>{
      if(e.target.id == "gift-submit"){
        if (window.giftWrapProduct){
          ShopifyAPI.getCart(giftWrap);
        }
      }
    });
    giftWrap = function (cart) {
      let giftMessage = document.getElementById("gift-note"),
          giftRecipient = document.getElementById("gift-recipient");
      if(giftRecipient.value.length == 0){
        document.getElementById("gift-error").style.display = "block";
      }else{
        document.getElementById("gift-error").style.display = "none";
        //determine if the giftwrap is already in cart so that multiples aren't added to the cart if the .
        let addData = {
          'items':[{
            'id': window.giftWrapProduct,
            'quantity': 1,
            'properties':{
              'Gift Recipient': giftRecipient.value,
              'Gift Message':giftMessage.value
            }
          }]
        }
        if(cart.items.some(e => e.handle == "gift-wrap")){
          let giftLine = cart.items.findIndex(e => e.handle == "gift-wrap") + 1;
          ShopifyAPI.changeItem(giftLine, 0, function(){
            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body:JSON.stringify(addData)
            }).then(() => {
                ShopifyAPI.getCart(cartUpdateCallback);
            }).catch((error) => {
              console.error('Error:', error);
            });
          });
        }else{
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body:JSON.stringify(addData)
          }).then(() => {
              ShopifyAPI.getCart(cartUpdateCallback);
          }).catch((error) => {
            console.error('Error:', error);
          });
        }
      }
    }
  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));
